/* This starts the components of the React application. 
To that end, it also determines the highest level ordering of them.
It exists by React convention. */

import React from 'react'
import UserslocalConnectContainer from './UserslocalConnectContainer'
import SendConnectContainer from './SendConnectContainer'
import SendWriteConnectContainer from './SendWriteConnectContainer'
import TempLoginFormConnectContainer from './TempLoginFormConnectContainer'
import Header from './Header'
if(sessionStorage.getItem("isTempLoginFormVisible") == null){
    sessionStorage.setItem("isTempLoginFormVisible", true);
}
const App = () => (
    <div>
    <Header />
    <TempLoginFormConnectContainer />
    <div class="divcontainer">
    <UserslocalConnectContainer />
    <SendConnectContainer />
    <SendWriteConnectContainer />
    </div>
</div> 
)

export default App


// WEBPACK FOOTER //
// ./src/App.js